/* eslint-disable camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useReducer } from "react";
import { tipStatus } from "../Utils/autocompleteEnum";
import { VehicleModel } from "../Models/VehicleModel";
import { toast } from "react-toastify";
import { Vocabulary } from "../Utils/Vocabulary";
import moment from "moment";
import {
  formatDateForSave,
  mapDotariToIds,
  mergeIndexes,
  buildModifyByEntry,
  mergeModifyBy,
  shapeInvoicesFromResponse,
} from "../Domain/Vehicle/vehicleTransformations";
import {
  saveVehicleRequest,
  buildVehicleFileFormData,
  saveVehicleFileRequest,
  updateVehicleAfterFileSave,
  saveMainImageRequest,
} from "../Services/vehicleApi";

export const VehicleContext = createContext({
  invoices: {
    OPInvoice: [],
    clientInvoice: [],
    providerInvoice: [],
    reservedDocuments: [],
  },
  vehicle: new VehicleModel(),
  documents: [],
  images: [],
});

const actions = {
  ON_CHANGE_VEHICLE: "ON_CHANGE_VEHICLE",
  ON_CHANGE_VEHICLE_PRICES: "ON_CHANGE_VEHICLE_PRICES",
  CHANGE_VEHICLE_ACQUISITION_DATE: "CHANGE_VEHICLE_ACQUISITION_DATE",
  CHANGE_VEHICLE_RESERVATION_DATE: "CHANGE_VEHICLE_RESERVATION_DATE",
  CHANGE_VEHICLE_TRANSPORT_DATE: "CHANGE_VEHICLE_TRANSPORT_DATE",
  CHANGE_VEHICLE_TRANSPORT_ESTIMATED_DATE:
    "CHANGE_VEHICLE_TRANSPORT_ESTIMATED_DATE",
  UPDATE_VEHICLE: "UPDATE_VEHICLE",
  UPDATE_VEHICLE_INVOICES: "UPDATE_VEHICLE_INVOICES",
  UPDATE_VEHICLE_DOCUMENTS: "UPDATE_VEHICLE_DOCUMENTS",
  UPDATE_VEHICLE_IMAGES: "UPDATE_VEHICLE_IMAGES",
  UPDATE_VEHICLE_INVOICE_TYPE: "UPDATE_VEHICLE_INVOICE_TYPE",
  RESET_STATE: "RESET_STATE",
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case actions.ON_CHANGE_VEHICLE_PRICES:
      return {
        ...state,
        vehicle: {
          ...state.vehicle,
          [action.state.name]: parseFloat(action.state.value),
        },
      };
    case actions.ON_CHANGE_VEHICLE:
      return {
        ...state,
        vehicle: { ...state.vehicle, [action.state.name]: action.state.value },
      };
    case actions.CHANGE_VEHICLE_ACQUISITION_DATE:
      return {
        ...state,
        vehicle: { ...state.vehicle, data_achizitie: action.state?._d },
      };
    case actions.CHANGE_VEHICLE_RESERVATION_DATE:
      return {
        ...state,
        vehicle: {
          ...state.vehicle,
          data_rezervare: action?.state?._d ? action.state?._d : null,
        },
      };
    case actions.CHANGE_VEHICLE_TRANSPORT_DATE:
      return {
        ...state,
        vehicle: {
          ...state.vehicle,
          pickupDate: action?.state?._d ? action.state?._d : null,
        },
      };
    case actions.CHANGE_VEHICLE_TRANSPORT_ESTIMATED_DATE:
      return {
        ...state,
        vehicle: {
          ...state.vehicle,
          estimatedArrivalDate: action?.state?._d ? action.state?._d : null,
        },
      };
    case actions.UPDATE_VEHICLE:
      return {
        ...state,
        vehicle: action.state,
      };
    case actions.UPDATE_VEHICLE_INVOICES:
      return {
        ...state,
        invoices: action.state,
      };
    case actions.UPDATE_VEHICLE_DOCUMENTS:
      return {
        ...state,
        documents: action.state,
      };
    case actions.UPDATE_VEHICLE_IMAGES:
      return {
        ...state,
        images: action.state,
      };
    case actions.UPDATE_VEHICLE_INVOICE_TYPE:
      return {
        ...state,
        invoices: {
          ...state.invoices,
          [action.state.name]: action.state.value,
        },
      };
    case actions.RESET_STATE:
      return { ...action.state };
    default:
      throw Error(`Unknown action: ${action.type}`);
  }
}

export const VehicleContextProvider = (props: any) => {
  const initState: any = {
    invoices: {
      OPInvoice: new Array<any>(),
      clientInvoice: new Array<any>(),
      providerInvoice: new Array<any>(),
      reservedDocuments: new Array<any>(),
    },
    vehicle: new VehicleModel(),
    documents: [],
    images: [],
  };

  const [state, dispatch] = useReducer(reducer, initState);

  const value: any = {
    state: state,
    /**
     *
     * @param state
     */
    onChangeVehicle: (state: any) => {
      dispatch({ type: actions.ON_CHANGE_VEHICLE, state });
    },
    /**
     *
     * @param state
     */
    onChangeVehiclePrices: (state: any) => {
      dispatch({ type: actions.ON_CHANGE_VEHICLE_PRICES, state });
    },

    /**
     *
     * @param state
     */
    onChangeVehicleAcquisitionDate: (state: any) => {
      dispatch({ type: actions.CHANGE_VEHICLE_ACQUISITION_DATE, state });
    },
    /**
     *
     * @param state
     */
    onChangeVehicleReservationDate: (state: any) => {
      dispatch({ type: actions.CHANGE_VEHICLE_RESERVATION_DATE, state });
    },
    /**
     *
     * @param state
     */
    onChangeVehicleTransportDate: (state: any) => {
      dispatch({ type: actions.CHANGE_VEHICLE_TRANSPORT_DATE, state });
    },
    /**
     *
     * @param state
     */
    onChangeVehicleTransportEstimatedDate: (state: any) => {
      dispatch({
        type: actions.CHANGE_VEHICLE_TRANSPORT_ESTIMATED_DATE,
        state,
      });
    },

    /**
     *
     * @param state
     */
    updateVehicle: (state: any) => {
      dispatch({ type: actions.UPDATE_VEHICLE, state });
    },
    /**
     *
     * @param state
     */
    updateVehicleInvoices: (state: any) => {
      dispatch({ type: actions.UPDATE_VEHICLE_INVOICES, state });
    },
    /**
     *
     * @param state
     */
    updateVehicleDocuments: (state: any) => {
      dispatch({ type: actions.UPDATE_VEHICLE_DOCUMENTS, state });
    },
    /**
     *
     * @param state
     */
    updateVehicleImages: (state: any) => {
      dispatch({ type: actions.UPDATE_VEHICLE_IMAGES, state });
    },
    /**
     *
     * @param state
     */
    updateVehicleInvoiceType: (state: any) => {
      dispatch({ type: actions.UPDATE_VEHICLE_INVOICE_TYPE, state });
    },
    /**
     *
     * @param state
     */
    resetState: (state: any) => {
      dispatch({ type: actions.RESET_STATE, state });
    },
    saveWithFile: saveVehicleWithFile,
    saveWithoutFile: saveWithoutFile,
    updateIndex: updateIndex,
    updateModifyBy: updateModifyBy,
    saveMainImage: saveMainImage,
  };

  /**
   * records the currently added indexes as a modification-audit entry
   * @param addedIndexes
   */
  function recordIndexModification(addedIndexes: string[]) {
    return updateModifyBy([
      buildModifyByEntry(
        addedIndexes,
        localStorage.getItem("userName"),
        moment().format("DD-MM-YYYY HH:mm:ss")
      ),
    ]);
  }

  /**
   *  saves a vehicle with a file
   * @param fileType
   * @param documentType
   * @param validate
   */
  async function saveWithoutFile(
    validate: () => boolean,
    addIndex?: string[],
    removeIndex?: string[],
    updateLocalValues?: any,
    disableTostify?: boolean
  ) {
    return new Promise((resolve, reject) => {
      let newVehicleData = { ...state.vehicle };

      newVehicleData.data_achizitie = formatDateForSave(
        newVehicleData.data_achizitie
      );

      if (updateLocalValues) {
        newVehicleData = { ...newVehicleData, ...updateLocalValues };
      }

      newVehicleData.dotari = mapDotariToIds(newVehicleData.dotari);

      if (addIndex?.length) {
        newVehicleData.indexes = updateIndex(addIndex, removeIndex);
        newVehicleData.modifyBy = recordIndexModification([...addIndex]);
      }

      if (validate()) {
        saveVehicleRequest(newVehicleData, disableTostify)
          .then((response: any) => {
            //update after save
            if (response) {
              dispatch({
                type: actions.UPDATE_VEHICLE,
                state: response.data.data,
              });
              resolve(response.data);
            }
          })
          .catch((error: any) => {
            reject(error);
          });
      }
    });
  }

  /**
   *  saves a vehicle with a file
   * @param fileType
   * @param documentType
   * @param validate
   */
  async function saveVehicleWithFile(
    parentDocArrayName: any,
    fileType: string,
    documentType: string,
    validate: () => boolean,
    addIndex?: string[],
    removeIndex?: string[],
    updateLocalValues?: any
  ) {
    return new Promise((resolve, reject) => {
      const parentDocArray = state.invoices[parentDocArrayName];
      const formData = buildVehicleFileFormData(
        state.vehicle,
        parentDocArray,
        fileType,
        documentType,
        tipStatus[1].nume
      );

      let newVehicleData = { ...state.vehicle };
      newVehicleData.dotari = mapDotariToIds(newVehicleData.dotari);

      if (addIndex?.length) {
        newVehicleData.indexes = updateIndex(addIndex, removeIndex);
        newVehicleData.modifyBy = recordIndexModification([...addIndex]);
      }

      if (newVehicleData.data_achizitie) {
        newVehicleData.data_achizitie = formatDateForSave(
          newVehicleData.data_achizitie
        );
      }
      if (updateLocalValues) {
        newVehicleData = { ...newVehicleData, ...updateLocalValues };
      }

      if (validate()) {
        saveVehicleFileRequest(
          formData,
          parentDocArray[0]?.id,
          state.vehicle.id,
          fileType
        )
          .then((res: any) => {
            dispatch({
              type: actions.UPDATE_VEHICLE_INVOICES,
              state: shapeInvoicesFromResponse(res.data),
            });

            dispatch({
              type: actions.UPDATE_VEHICLE_DOCUMENTS,
              state: res.data.documents,
            });

            updateVehicleAfterFileSave(state.vehicle?.id, newVehicleData)
              .then((response: any) => {
                //update indexes after save
                dispatch({
                  type: actions.UPDATE_VEHICLE,
                  state: response.data.data,
                });
                resolve(true);
              })
              .catch(() => {
                reject();
              });
          })
          .catch(() => {
            // console.log(error);
            reject();
            toast.error(Vocabulary.error);
          });
      }
    });
  }

  /**
   * adds or remove indexes from vehicle
   * @param addIndex
   * @param removeIndex
   * @returns
   */
  function updateIndex(addIndex?: string[] | any, removeIndex?: string[]) {
    const indexes = mergeIndexes(state?.vehicle?.indexes, addIndex, removeIndex);
    dispatch({
      type: actions.ON_CHANGE_VEHICLE,
      state: { name: "indexes", value: indexes },
    });
    return indexes;
  }

  function updateModifyBy(addIndex?: any) {
    const indexes = mergeModifyBy(state.vehicle.modifyBy, addIndex ?? []);
    dispatch({
      type: actions.ON_CHANGE_VEHICLE,
      state: { name: "modifyBy", value: indexes },
    });
    return indexes;
  }
  /**
   *
   * @param image
   * @param vehicleId
   * @returns
   */
  async function saveMainImage(file: File, vehicleId: number | string) {
    return new Promise((resolve, reject) => {
      saveMainImageRequest(file, vehicleId)
        .then((response: any) => {
          //update after save
          if (response) {
            dispatch({
              type: actions.UPDATE_VEHICLE,
              state: response.data.data,
            });
            resolve(response.data);
          }
        })
        .catch((error: any) => {
          reject(error);
        });
    });
  }

  return (
    <VehicleContext.Provider value={value}>
      {props.children}
    </VehicleContext.Provider>
  );
};
